import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { getRelativeUrl } from '@utils'
import winPixel from '@utils/winPixel'
import { useLocation } from 'react-router-dom'

export const useProducts = (isMobild?: boolean, props?: any) => {
  const { params, pageType, onFetch, onChangePage } = props
  // store数据
  const productsData = useSelector((state: any) => state.products, shallowEqual)
  const {
    categoryName,
    categoriesImg,
    categoriesDescription,
    pageTitle,
    pageDesc,
    productList,
    productCount,
    pageSize,
    page,
    navBread,
    maxPrice,
    metaInfo,
    mCategoriesImg,
    flashEndTime
  } = productsData?.data || {}
  const filterData = productsData?.filter || {}
  const location = useLocation()
  const pathname = location.pathname
  const isFlash = pathname.indexOf('/flashDeal') > -1
  const isSearch = pathname.indexOf('/search') > -1
  // 面包屑
  const [breadcrumbItems, setBreadcrumbItems] = useState([])
  useEffect(() => {
    let arr: any = []
    if (navBread?.length) {
      navBread.forEach((nav: any) => {
        arr.push({ title: nav.title, href: getRelativeUrl(nav.href) })
      })
    }
    setBreadcrumbItems(arr)
    // if (isSearch && params.keywords) {
    //   winPixel.search(params.keywords, productList.length)
    // }
  }, [navBread])

  useEffect(() => {
    if (productsData) {
      const productSkuIds = productsData?.data?.productList?.map((item) => {
        return item.productsSkuId
      })
      winPixel.pLoad.category(productSkuIds, productsData?.data?.categoryName)
    }
  }, [productsData])

  const [pageName, setPageName] = useState('')
  useEffect(() => {
    switch (pageType) {
      case 1:
        setPageName('Flash Sale')
        break
      case 2:
        setPageName('Best Sellers')
        break
      case 3:
        setPageName('New Arrivals')
        break
      default:
        setPageName('')
        break
    }
  }, [pageType])

  // 属性更新
  const changeAttrSelect = (obj: any) => {
    let newObj: any = { ...obj }
    if (!isMobild) {
      newObj.page = 1
    }
    onFetch && onFetch({ ...newObj })
  }

  // 排序更新
  const handleChangeSort = (value: string) => {
    let newValue = value
    if (value === 'price') {
      if (params.order === '2') {
        newValue = '3' // 降序
      } else {
        newValue = '2' // 升序
      }
    }
    let newObj: any = { order: newValue }
    if (!isMobild) {
      newObj.page = 1
    }
    onFetch && onFetch({ ...newObj })
  }

  const changePage = (...arg) => {
    onChangePage(...arg)
  }

  // attr选择属性改变时触发
  const [display, setDisplay] = useState([])
  // 滑块区间
  const [sliderDisplay, setSliderDisplay] = useState([])
  useEffect(() => {
    if (!filterData?.filterList?.length) return
    const { filterValueIds, filterCat } = params
    const filtersValues = filterValueIds ? filterValueIds.split(',') : []
    const filterCats = filterCat ? filterCat.split(',') : []
    const filters = [...filtersValues, ...filterCats]
    if (filters.length) {
      let arrs = []
      // 判断类目是's', 还是'c'，两者结构不同
      const isScate =
        filterData.filterList?.find((i) => i.productsOptionsId === 's') || {}
      if (isScate.productsOptionsId === 's') {
        const newArr =
          filterData.filterList
            ?.find((i) => i.productsOptionsId === 's')
            ?.productsOptionValuesList?.flatMap((c) => c.children)
            ?.filter((item) => filters.includes(item?.id + ''))
            .map((item) => {
              return {
                ...item,
                productsOptionsId: 's'
              }
            }) || []
        const norArr =
          filterData.filterList
            ?.filter((i) => i.productsOptionsId !== 's')
            ?.flatMap((k) => k.productsOptionValuesList)
            ?.filter((item) =>
              filters.includes(item?.productsOptionsValuesId + '')
            ) || []
        arrs = [...newArr, ...norArr]
      } else {
        arrs = filterData.filterList
          ?.flatMap((k) => k.productsOptionValuesList)
          ?.filter((item) =>
            filters.includes(item?.productsOptionsValuesId + '')
          )
      }
      setDisplay(arrs || [])
    } else {
      setDisplay([])
    }
  }, [params.filterValueIds, params.filterCat, filterData.filterList])

  useEffect(() => {
    const minMaxArr = ['Price', 'Width', 'Depth', 'Height'].filter((i) => {
      const str = `min${i}` || `max${i}`
      const arr = Object.keys(params)
      return params[`max${i}`] && arr.includes(str)
    })

    const list =
      filterData.filterList?.find((i) => i.productsOptionsId === 'wdh')
        ?.wdhList || []

    const newList = minMaxArr.map((item) => {
      if (item === 'Price') {
        return {
          label: item,
          valueUnit: '$' || ''
        }
      } else {
        const { valueUnit } =
          list.find((l) => l.key?.toLowerCase() === item.toLowerCase()) || {}
        return {
          label: item,
          valueUnit: valueUnit || ''
        }
      }
    })

    setSliderDisplay(newList || [])
  }, [params])

  // 删除某个选中
  const removeActive = (
    v: string | number,
    paramKey?: string,
    isOther?: boolean
  ) => {
    React.startTransition(() => {
      const data = JSON.parse(JSON.stringify(params))
      const value = String(v)
      let obj: any = {}
      if (isOther) {
        obj[`min${paramKey}`] = undefined
        obj[`max${paramKey}`] = undefined
      } else {
        let ids = data[paramKey]?.split(',') || []
        if (ids.indexOf(value) === -1) {
          ids.push(value)
        } else {
          ids.splice(ids.indexOf(value), 1)
        }
        obj[paramKey] = ids.filter((el: string) => el !== '').join(',')
      }
      let newObj: any = { ...obj }
      if (!isMobild) {
        newObj.page = 1
      }
      onFetch && onFetch(newObj)
    })
  }
  // 删除switch
  const removeSwitch = (key) => {
    const newObj = JSON.parse(JSON.stringify(params))
    newObj[key] = undefined
    if (!isMobild) {
      newObj.page = 1
    }
    onFetch && onFetch(newObj)
  }
  // 直接重置
  const removeAll = () => {
    const obj = JSON.parse(JSON.stringify(params)) || {}
    for (let item in obj) {
      if ({}.hasOwnProperty.call(obj, item)) {
        // 排除
        if (
          ![
            'catId',
            'manualControl',
            'order',
            'page',
            'pageSize',
            'type',
            'keywords'
          ].includes(item)
        ) {
          obj[item] = undefined
        }
      }
    }
    let newObj: any = { ...obj }
    if (!isMobild) {
      newObj.page = 1
    }
    onFetch && onFetch(newObj)
  }

  const [sortLabelShow, setSortLabelShow] = useState('Recommended')

  useEffect(() => {
    let str = ''
    switch (params.order) {
      case '1':
        str = 'Recommended'
        break
      case '2':
        str = 'Price - High to Low'
        break
      case '3':
        str = 'Price - Low to High'
        break
      case '4':
        str = 'New Arrival'
        break
      case '5':
        str = 'Customer Rating'
        break
    }
    setSortLabelShow(str)
  }, [params.order])

  return {
    metaInfo,
    navBread,
    breadcrumbItems,
    pageName,
    productList,
    categoriesImg,
    mCategoriesImg,
    categoryName,
    categoriesDescription,
    pageTitle,
    pageDesc,
    filterData,
    pageSize,
    productCount,
    changeAttrSelect,
    productsData,
    display,
    sliderDisplay,
    removeActive,
    removeSwitch,
    maxPrice,
    removeAll,
    handleChangeSort,
    page,
    changePage,
    sortLabelShow,
    banners: productsData?.banners,
    flashEndTime
  }
}
